import { DataProvider } from "@/providers/DataProvider";
import { LocalStorageService } from "@/services/StorageService";
import { HomePage } from "@/views/HomePage";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import ErrorPage from "@/views/ErrorPage";
import { Root } from "@/views/Root";
import { CategoryPage } from "@/views/CategoryPage";
import { CategoryListDialog } from "@/views/CategoryListDialog";
import { TagListDialog } from "./views/TagListDialog";
import TaskCreateDialog from "./views/TaskCreateDialog";
import TaskEditDialog from "./views/TaskEditDialog";

const router = createBrowserRouter([
  {
    path: "/",
    element: <Root />,
    errorElement: <ErrorPage />,
    children: [
      {
        index: true,
        element: <HomePage />,
      },
      {
        path: "tasks",
        element: <HomePage />,
        children: [
          {
            path: "manageCategories",
            element: <CategoryListDialog />,
          },
          {
            path: "manageTags",
            element: <TagListDialog />,
          },
          {
            path: "create",
            element: <TaskCreateDialog />,
          },
          {
            path: "edit/:taskId",
            element: <TaskEditDialog />,
          },
        ],
      },
      {
        path: "category/:categoryId",
        element: <CategoryPage />,
      },
    ],
  },
]);

function App() {
  return (
    <DataProvider
      storageService={new LocalStorageService("tasker_app_storage_v1")}
    >
      <RouterProvider router={router} />
    </DataProvider>
  );
}

export default App;
